export const BASE_URL = 'https://api.github.com/users/';
export default BASE_URL;
